import type { ComponentContentSchema } from '@vibesites/runtime';

/**
 * Price Brothers override: special offers are not used on these sites at this
 * time, so the inherited banner AND its floating "Special Offer" reopen pill
 * are both suppressed by rendering nothing. Remove this override to restore
 * the parent theme's SpecialOfferBanner.
 */
export function SpecialOfferBanner() {
  return null;
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SpecialOfferBanner',
  displayName: 'Special Offer Banner',
  tokens: {},
  slotGroups: {},
  collectionBindings: {
    'specialofferbanner.items': {
      label: 'Special Offers',
      collection: 'special_offers',
    },
  },
};

(SpecialOfferBanner as any).contentSchema = contentSchema;

export default SpecialOfferBanner;
